import * as React from 'react'
import { Breadcrumbs, Typography } from '@mui/material'
import { NavigateNext } from '@mui/icons-material'
import Link from 'next/link'

export interface IBaseBreadcrumbItem {
  path: string
  title: string
  isActive?: boolean
  style?: any
}

const BaseBreadcrumbComponent = (props: {
  items: Array<IBaseBreadcrumbItem>
}) => {
  return (
    <Breadcrumbs
      separator={<NavigateNext fontSize="small" />}
      style={{ padding: '20px 20px' }}
      aria-label="breadcrumb"
      color={'primary'}
    >
      {props.items.map(c => {
        return (
          // <Link
          //   key={c.path}
          //   href={c.path}
          //   // onClick={() => {
          //   //   router.push(c.path); // TODO: This doesnt work for path that is not the same as file path e.g /dashboard for admin
          //   // }}
          //   style={{ cursor: "pointer", ...c.style }}
          // >
          <Typography
            color={c.isActive ? 'primary' : 'textPrimary'}
            style={{ textDecoration: 'none' }}
            component={Link}
            href={c.path}
            variant={'body2'}
          >
            {c.title}
          </Typography>
          // </Link>
        )
      })}
    </Breadcrumbs>
  )
}

export default BaseBreadcrumbComponent
